import * as styles from '../../styles/components/Error.less';
import React from 'react';

interface ErrorProps {
  message: string;
}

const Error = ({ message }: ErrorProps) => {
  return (
    <div className={styles.error}>
      {message}
    </div>
  );
};

export default React.memo(Error);
